import { dataUserCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserCircle = /*#__PURE__*/createIcon(dataUserCircle)
export default IconUserCircle
